import { useEffect, useMemo, useState } from "react";

import { getCommunicationList } from "shared/api/InquirySuggestApi";
import { toKstDate } from "shared/lib/date/formatKst";

export function useCommunicationListPage({
  fetchPath,
  filterFn,
  itemsPerPage = 7,
}) {
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    const readItems = async () => {
      try {
        const list = await getCommunicationList(fetchPath);

        setItems(list);
        setFilteredItems(list);
      } catch (error) {
      }
    };

    readItems();
  }, [fetchPath]);

  const sortedItems = useMemo(
    () => [...filteredItems].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
    [filteredItems],
  );

  const visibleItems = useMemo(() => {
    const startIndex = (page - 1) * itemsPerPage;

    return sortedItems.slice(startIndex, startIndex + itemsPerPage);
  }, [itemsPerPage, page, sortedItems]);

  const newPostsCount = useMemo(() => {
    const today = new Date();

    return items.filter((item) => {
      // createdAt은 서버가 UTC로 생성하므로 KST 보정 후 오늘 여부 비교.
      const postDate = toKstDate(item.createdAt);

      return (
        postDate &&
        postDate.getDate() === today.getDate() &&
        postDate.getMonth() === today.getMonth() &&
        postDate.getFullYear() === today.getFullYear()
      );
    }).length;
  }, [items]);

  const handleSearchFilters = (filters) => {
    setPage(1);
    setFilteredItems(filterFn(items, filters));
  };

  // 초기화 시 전체 목록으로 되돌린다.
  const handleReset = () => {
    setPage(1);
    setFilteredItems(items);
  };

  return {
    page,
    setPage,
    filteredItems,
    visibleItems,
    newPostsCount,
    itemsPerPage,
    handleSearchFilters,
    handleReset,
  };
}
